"use client";

import { useQuery } from "@tanstack/react-query";

import { getDocumentManagementInstructions } from "@/src/requests/document-management-instructions";

const DOCUMENT_MANAGEMENT_INSTRUCTIONS_CACHE_KEY = "document-management-instructions";

export function useDocumentManagementInstructions(taskId: string, options?: { enabled?: boolean }) {
  const query = useQuery({
    queryKey: [DOCUMENT_MANAGEMENT_INSTRUCTIONS_CACHE_KEY, taskId],
    queryFn: () => getDocumentManagementInstructions(taskId),
    enabled: !!taskId,
  });

  return {
    instructions: query.data?.instructions,
    stepOutputs: query.data?.stepOutputs,
    ccDescription: query.data?.ccDescription ?? null,
    isFetching: query.isFetching,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
